import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { CurrencyUpdateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type CurrencyUpdateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  code: string;
  codeSelectedValue?: { displayId: string; id: string } | null;
  onCodeChange?: (value: string) => void;
  codeError?: string;
  name: string;
  nameSelectedValue?: { displayId: string; id: string } | null;
  onNameChange?: (value: string) => void;
  nameError?: string;
  currencyUpdateStore: CurrencyUpdateStore;
};

export const CurrencyUpdateForm: React.FC<CurrencyUpdateFormProps> = observer(
  ({
    onSave = () => {},
    onCancel = () => {},
    saving = false,
    showToolbox = true,
    showSaveFooter,
    code = "",
    codeError,
    onCodeChange = () => {},
    name = "",
    nameError,
    onNameChange = () => {},
    currencyUpdateStore,
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            saveAndCloseLabel={langStore.saveEntity}
            closeLabel={langStore.cancelUpdatedEntity}
            saveForm={() => onSave()}
            saveDisabled={saving}
            closeForm={() => onCancel()}
          />
        )}
        <Box>
          <FormExtras
            entity="Currency"
            mode="update"
            values={{}}
            options={{}}
            onPatch={(campo: string, valor: any) => {
              switch (campo) {
                case "code":
                  onCodeChange?.(valor);
                  break;
                case "name":
                  onNameChange?.(valor);
                  break;
              }
            }}
          />
          <GroupContainer
            id="null"
            errorText={currencyUpdateStore.getCardErrors("null")}
            title={langStore.groupCurrencyLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <InputString
                autoFocus
                value={code}
                error={Boolean(codeError)}
                warning={
                  !codeError && Boolean(currencyUpdateStore.warnings["code"])
                }
                helperText={
                  codeError || currencyUpdateStore.warnings["code"]?.message
                }
                label={langStore.CurrencyCodeLabel}
                onChange={(value: string) => onCodeChange(value)}
                description={langStore.CurrencyCodeDescription}
              />
              <InputString
                value={name}
                error={Boolean(nameError)}
                warning={
                  !nameError && Boolean(currencyUpdateStore.warnings["name"])
                }
                helperText={
                  nameError || currencyUpdateStore.warnings["name"]?.message
                }
                label={langStore.CurrencyNameLabel}
                onChange={(value: string) => onNameChange(value)}
                description={langStore.CurrencyNameDescription}
              />
            </FormControl>
          </GroupContainer>
        </Box>
        {(showSaveFooter ?? !showToolbox) && (
          <FormSaveFooter
            onSave={() => onSave()}
            label={langStore.saveEntity}
            disabled={saving}
          />
        )}
      </Grid>
    );
  }
);
